function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.154 2.077A3.77 3.77 0 006.546 6.94a.538.538 0 01-.135.537L2.13 11.76a.18.18 0 00-.052.127v1.857c0 .099.08.18.18.18h1.615v-.898c0-.298.24-.539.538-.539h.898v-.897c0-.298.24-.539.538-.539H7.06L8.522 9.59a.538.538 0 01.537-.135 3.77 3.77 0 101.095-7.377zm-4.846 3.77a4.846 4.846 0 113.756 4.722L7.663 11.97a.538.538 0 01-.381.158h-.897v.898a.538.538 0 01-.539.538H4.95v.897A.538.538 0 014.41 15H2.256A1.256 1.256 0 011 13.744v-1.857c0-.333.132-.653.368-.888l4.063-4.063a4.86 4.86 0 01-.123-1.09zM9.615 4.41c0-.297.241-.538.539-.538 1.09 0 1.974.884 1.974 1.974a.538.538 0 01-1.077 0 .897.897 0 00-.897-.897.538.538 0 01-.539-.539z",
  fill: "#2D2D2D"
});
function SvgLlave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Llave.svg";
export { SvgLlave as ReactComponent };